import React from 'react';
import { NewsSchedule } from './NewsSchedule';
import { AnnotatedCommentary } from './AnnotatedCommentary';
import { NewNGJob } from '../types';
import { useNewNG } from '../context/NewNGContext';
import Typography from '../../../basic/Typography';
import styles from '../NewNG.module.css';

interface VideoInfoSectionProps {
  currentJob?: NewNGJob | null;
  onVideoFocus?: () => void;
}

export const VideoInfoSection: React.FC<VideoInfoSectionProps> = ({ currentJob, onVideoFocus }) => {
  const { dispatch } = useNewNG();

  // Handle job selection from schedule
  const handleJobSelect = (job: NewNGJob) => {
    dispatch({ type: 'SET_CURRENT_JOB', payload: job });

    // Focus the video section after job change
    if (onVideoFocus) {
      onVideoFocus();
    }
  };
  // Format date for display
  const formatDate = (dateString: string) => {
    try {
      return new Date(dateString).toLocaleDateString('en-US', {
        weekday: 'short',
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch {
      return dateString;
    }
  };

  return (
    <div className={styles['newng-video-info-section']}>
      {/* Compact Job Header */}
      {currentJob && (
        <div className={styles['newng-job-header']}>
          <div className={styles['newng-job-meta']}>
            <Typography variant="caption" component="span" className={styles['newng-job-hash-label']}>
              Hash:
            </Typography>
            <Typography variant="caption" component="span" className={styles['newng-job-id']}>
              {currentJob.job_id?.substring(0, 5)}..
            </Typography>
            <Typography variant="caption" component="span" className={styles['newng-job-separator']}>
              •
            </Typography>
            <Typography variant="caption" component="span" className={styles['newng-job-date']}>
              {currentJob.created_at ? formatDate(currentJob.created_at) : 'Unknown date'}
            </Typography>
          </div>
        </div>
      )}

      {/* Main Content */}
      <AnnotatedCommentary />
      <NewsSchedule currentJob={currentJob} onJobSelect={handleJobSelect} />
    </div>
  );
};